   'use client';

   import { useEffect, useState } from 'react';
   import { useRouter } from 'next/navigation';
   import { SignInViewPage } from '@/sections/auth/view';

   export default function RootPage() {
   	const router = useRouter();
   	const [isLoading, setIsLoading] = useState(true);
   	const [isAuthenticated, setIsAuthenticated] = useState(false);

   	useEffect(() => {
  		const token = localStorage.getItem('token');
   		const user = localStorage.getItem('user');

   		if (token && user) {
   			setIsAuthenticated(true);
           		router.replace('/dashboard');
         	} else {
         		setIsAuthenticated(false);
         		setIsLoading(false);
        	}
     	 }, [router]);
  
  		if (isLoading && isAuthenticated) {
		return (
            <div className="flex h-screen items-center justify-center">
                <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
            </div>
		);
		}
		return <SignInViewPage />;
  }